
var $body,
    $window,
    $header,
    $menuOpen,
    $menuClose,
    $mainMenu,
    $submenus,
    $submenuOpen,
    $submenuClose,
    $submenuAccordionOpen,
    $toggleFooterMenu,
    $sliders,
    $reviewSliders,
    $productSliders,
    $playVideo,
    $toggleAccordion,
    $slideIn,
    $slideInClose,
    $labelToggle,
    $bookingClose,
    $bookingOpen,
    $booking,
    $bookingPopup,
    $bookingPopupOpen,
    $bookingPopupClose,
    $cartCounter,
    $cartNumber;

// Scroll vars
var lastScrollTop;
var lastScrollTopDirection = 0;
var scrollTop;
var scrollOffset = 25; // offset when header should toggle

// Preset vars
var breakpointMobile = 767; // MD breakpoint -1

// Request animation frame (cross browser)
var raf = window.requestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          window.msRequestAnimationFrame ||
          window.oRequestAnimationFrame;

$(document).ready(function($) {

    // Console log logo
    console.log('%cLinku Novio',"font-size: 2em; font-family: sans-serif; color: white; background-color:#18aaff; padding:4px 8px; border-radius: 4px");

    $body = $('body');
    $window = $(window);
    $header = $('.js-header');
    $cartCounter = $('.is-cart .c-menu__counter');
    $cartNumber = $('.is-cart .c-menu__counter__number');
    $menuOpen = $('.js-menu-open');
    $menuClose = $('.js-menu-close');
    $mainMenu = $('.js-main-menu');
    $submenus = $('.js-submenu');
    $submenuOpen = $('.js-submenu-open');
    $submenuClose = $('.js-submenu-close');
    $submenuAccordionOpen = $('.js-menu-accordion-open');
    $toggleFooterMenu   = $('.js-footer-menu');
    $sliders = $('.js-slider');
    $reviewSliders = $('.js-slider-review');
    $productSliders = $('.js-slider-product');
    $playVideo = $('.js-video-play');
    $toggleAccordion = $('.js-toggle-accordion');
    $slideIn = $('.js-slide-in');
    $slideInClose = $('.js-slide-in-close');
    $bookingClose = $('.js-booking-close');
    $bookingOpen = $('.js-booking-open');
    $booking = $('.js-booking');
    $labelToggle = $('.js-toggle-label');
    $bookingPopup = $('.js-booking-popup');
    $bookingPopupOpen = $('.js-booking-popup-open');
    $bookingPopupClose = $('.js-booking-popup-close');

    // Fill scroll vars
    var lastScrollTop = $window.scrollTop();

    // Run startup functions
    if (raf) {
        loop();
    }

    /**
     * Shopping cart counter
     */
    if ($cartCounter) {
        var mageCacheStorage = window.localStorage.getItem('mage-cache-storage');
        if (mageCacheStorage) {
            var parsedStorage = JSON.parse(mageCacheStorage);
            if (parsedStorage && parsedStorage.cart && parsedStorage.cart.summary_count) {
                var cartCount = parsedStorage.cart.summary_count;
                if (cartCount > 0) {
                    $cartCounter.show();
                    $cartNumber.html(cartCount);
                }
            }
        } 
    }

    /* ----------------
     * LISTENERS
     * ---------------*/
    $menuOpen.on('click', function(e) {
        $mainMenu.addClass('is-open');
    });

    $menuClose.on('click', function(e) {
        $mainMenu.removeClass('is-open');
        $mainMenu.removeClass('has-open-submenu');
        $submenuOpen.parent().next().removeClass('is-open');
        $submenus.removeClass('is-open');
    });

    $submenuOpen.on('click', function(e) {
        $(this).parent().next().addClass('is-open');
        $mainMenu.addClass('has-open-submenu');
    });

    $submenuClose.on('click', function(e) {
        $submenus.removeClass('is-open');
        $mainMenu.removeClass('has-open-submenu');
    });

    $playVideo.on('click', function() {
        var $target = $(this).parent();

        var $targetContainer = $target.next('.js-video');
        var firstLoad = ! $targetContainer.data('iframeLoaded');

        if(firstLoad) {
            var iframeHtml = $targetContainer.data('iframeHtml');
            $iframe = $(iframeHtml);
            $iframe.appendTo($targetContainer);
            $targetContainer.data('iframeLoaded', true);
        } else {
            var $iframe = $target.find('.js-video iframe');
        }

        if ($target.hasClass('is-active')) {
            $target.removeClass('is-active');
            var src = $iframe[0].src;
            src = src.replace("&autoplay=1", "");
            $iframe[0].src = src;
        } else {
            $target.addClass('is-active');
            $iframe[0].src += "&autoplay=1";
        }
    });

    $submenuAccordionOpen.on('click', function(e) {
        if ($(this).hasClass('is-open')) {
            $(this).removeClass('is-open');
            $(this).parent().next().slideUp();
        } else {
            $submenuAccordionOpen.removeClass('is-open');
            $submenuAccordionOpen.parent().next().slideUp();

            $(this).parent().next().slideDown();

            $(this).addClass('is-open');
        }
    });

    /*
     * Footer menu open/close for mobile
     */
    $toggleFooterMenu.on('click', function(e) {
        e.stopPropagation(); // To prevent double click action (the window click event)

        if (isMobile()) {
            if ($(this).hasClass('is-open')) {
                $(this).removeClass('is-open');
                $(this).next().slideUp();
            } else {
                $toggleFooterMenu.removeClass('is-open');
                $toggleFooterMenu.next().slideUp();
                $(this).addClass('is-open');
                $(this).next().slideDown();
            }
        }
    });

    $toggleAccordion.on('click', function(e) {
        e.stopPropagation();
        $parent = $(this).parent();

        if ($parent.hasClass('is-open')) {
            $parent.removeClass('is-open');
            $(this).next().stop().slideUp();

        } else {
            $toggleAccordion.parent().removeClass('is-open');
            $toggleAccordion.next().stop().slideUp();

            $parent.addClass('is-open');
            $(this).next().stop().slideDown();
        }
    });

    $labelToggle.on('click', function(){


        if($(window).width() < 992) { //lg breakpoint
            // code for things smaller than ipads
            if ($(this).hasClass('is-open')) {
                $(this).next().slideUp();
                $(this).removeClass('is-open')
            } else {
                $(this).siblings('.js-toggle-label').next().slideUp();
                $(this).next().slideDown();
                $(this).addClass('is-open')
            }
        } else {
            if ($(this).hasClass('is-open')) {
                return;
            }

            $(this).siblings().removeClass('is-open');
            $(this).addClass('is-open');
        }
    });

    $bookingOpen.on('click', function(e) {
        e.preventDefault();
        $booking.addClass('is-open');
    });

    $bookingClose.on('click', function() {
        $booking.removeClass('is-open');
    });

    $booking.on('click', function (e) {
        // Only catch a click on the outer div
        if (e.target === this) {
            $booking.removeClass('is-open');
        }
    });

    $bookingPopupOpen.on('click', function(e) {
        e.preventDefault();
        $bookingPopup.addClass('is-open');
    });

    $bookingPopupClose.on('click', function() {
        $bookingPopup.removeClass('is-open');
    });

    $bookingPopup.on('click', function (e) {
        // Only catch a click on the outer div
        if (e.target === this) {
            $bookingPopup.removeClass('is-open');
        }
    });

    /* Slide in actions */
    $slideInClose.on('click', function(){
        $(this).parent().removeClass('is-open');

        var cookieName = $(this).parent().attr('data-cookie-name');
        setCookie(cookieName, 'shown', 30);

    });

    // Open all slide after x seconds
    $slideIn.each(function() {
        var timer = $(this).attr('data-open-after');
        var $target = $(this);

        setTimeout(function() {
            $target.addClass('is-open')
        }, timer)
    });

    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    }
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
    function clearCookie(name) {
        setCookie(name, "", -1);
    }

    /* ----------------
     * SLIDERS
     * ---------------*/
    $sliders.each(function(index, value) {
        tns({
            container: value,
            autoplayTimeout: 5000,
            speed: 600,
            nav: true,
            autoplayButtonOutput: false,
            controls: false,
            controlsText: ["", ""],
            autoplay: true,
            mode: 'gallery',
            autoHeight: false
        });
    });

    $reviewSliders.each(function(index, value) {
        tns({
            container: value,
            autoplayTimeout: 5000,
            speed: 600,
            nav: false,
            gutter: 44,
            autoplayButtonOutput: false,
            controls: true,
            controlsText: ["<i class=\"fas fa-arrow-left\"></i>", "<i class=\"fas fa-arrow-right\"></i>"],
            autoplay: true,
            autoHeight: false,
            autoplayHoverPause: true,
            rewind: true,
            items: 1,
            responsive: {
                768: {
                    items: 2,
                },
                1200: {
                    items: 3,
                }
            }
        });
    });

    $productSliders.each(function(index, value) {
        tns({
            container: value,
            autoplayTimeout: 5000,
            speed: 600,
            nav: false,
            gutter: 0,
            autoplayButtonOutput: false,
            controls: true,
            controlsText: ["<i class=\"fas fa-arrow-left\"></i>", "<i class=\"fas fa-arrow-right\"></i>"],
            autoplay: true,
            autoHeight: false,
            autoplayHoverPause: true,
            rewind: true,
            items: 2,
            responsive: {
                768: {
                    items: 3,
                },
                1200: {
                    items: 4,
                }
            }
        });
    });

});

$(document).keyup(function(e) {
    if ($bookingPopup && e.key === 'Escape' && $bookingPopup.hasClass('is-open') === true) {
        $bookingPopup.removeClass('is-open');
    }
    if ($booking && e.key === 'Escape' && $booking.hasClass('is-open') === true) {
        $booking.removeClass('is-open');
    }
});

var scroll = function () {
    if (scrollTop > lastScrollTopDirection + scrollOffset && scrollTop > 150){
        scrollDown();
    } else if (scrollTop < lastScrollTopDirection - scrollOffset || scrollTop === 0){
        scrollUp();
    }
};

var scrollDown = function () {
    $header.addClass('is-scrolling-down');
    lastScrollTopDirection = scrollTop;
};

var scrollUp = function () {
    $header.removeClass('is-scrolling-down');
    lastScrollTopDirection = scrollTop;
};

function loop() {
    scrollTop = $window.scrollTop();
    if (lastScrollTop === scrollTop) {
        raf(loop);
        return;
    } else {
        lastScrollTop = scrollTop;

        // fire scroll function if scrolls vertically
        scroll();
        raf(loop);
    }
}

function isMobile() {
    return window.matchMedia("only screen and (max-width:" + breakpointMobile + "px)").matches;
}
